import {Component} from '@angular/core';


@Component({
    selector: 'bo-dashboard',
    templateUrl: 'back-office-dashboard.component.html'

})
export class BackOfficeDashboardComponent {

    constructor() {
    }
}




// WEBPACK FOOTER //
// ./src/app/component/back-office-dashboard/back-office-dashboard.component.ts